<template>
  <div class="d-flex align-items-center justify-content-between">
    <div v-if="currentRegistration" class="tw:flex-1">
      <RegistrationInfo :registration="currentRegistration" />
    </div>
    <div v-else>
      <span class="text-danger">{{ $t('No registration selected') }}</span>
    </div>
    <Dialog v-slot="{open}">
      <DialogTrigger class="btn btn-link">
        <i class="fa fa-pencil-square"></i>
      </DialogTrigger>
      <DialogScrollContent size="xl">
        <DialogHeader>
          <DialogTitle>
            {{ $t("Select a registration") }}
          </DialogTitle>
        </DialogHeader>
        <RegistrationIndex
          v-if="open && updateOrderUrl && canChangeRegistration"
          :current-registration="currentRegistration"
          :base-filters="baseFilters"
          :available-filters="availableFilters"
          :add-url="registrationAddUrl"
          @change-registration="updateRegistration($event)"
        >
        </RegistrationIndex>
      </DialogScrollContent>
    </Dialog>
  </div>
</template>

<script setup>
import RegistrationIndex from '@/components/registration/RegistrationIndex.vue'
import { Dialog, DialogScrollContent, DialogTrigger, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ref } from "vue";
import RegistrationInfo from "@/components/registration/RegistrationInfo.vue";

const props = defineProps({
  baseFilters: {
    type: Object,
    default: () => {}
  },
  availableFilters: {
    type: Array
  },
  registration: {
    type: Object,
    default: undefined
  },
  registrationAddUrl: {
    type: String,
    default: null,
  },
  updateOrderUrl: {
    type: String,
    default: null,
  },
  canChangeRegistration: {
    type: Boolean,
    default: false,
  },
});

const currentRegistration = ref(props.registration);

const updateRegistration = async (registration) => {
  try {
    const {data} = await axios.put(props.updateOrderUrl, {
      registration_id: registration.id,
      old_participant: currentRegistration.value ? currentRegistration.value.id : null,
    });
    currentRegistration.value = data.data.registration
    window.location.reload();
  } catch (e) {
    console.error(e)
  }
}

</script>
